import { c as _c } from "react/compiler-runtime";
import { iconMap, type IconName } from "@/lib/icons";
import { Globe, type LucideProps } from "lucide-react";
type IconProps = LucideProps & {
  name: IconName;
};
export function Icon(t0) {
  const $ = _c(8);
  let name;
  let props;
  if ($[0] !== t0) {
    ({
      name,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = name;
    $[2] = props;
  } else {
    name = $[1];
    props = $[2];
  }
  const Component = iconMap[name];
  if (!Component) {
    let t1;
    if ($[3] !== props) {
      t1 = <Globe {...props} />;
      $[3] = props;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  let t1;
  if ($[5] !== Component || $[6] !== props) {
    t1 = <Component {...props} />;
    $[5] = Component;
    $[6] = props;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}